import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';
import Services from '@/views/Services.vue';
import TicketingRequestList from '@/views/TicketingRequestList.vue';
import Reports from '@/views/Reports.vue';
import ReportHub from '@/views/ReportHub.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/map/:id',
    name: 'Map',
    component: Home
  },
  {
    path: '/services/:id',
    name: 'Services',
    component: Services
  },
  {
    path: '/ticketing-request/:id',
    name: 'TicketingRequest',
    component: Home
  },
  {
    path: '/ticketing-table/:id',
    name: 'TicketingRequestList',
    component: TicketingRequestList
  },
  {
    path: '/settings',
    name: 'Registry',
    component: () => import('@/components/settings/Registry.vue')
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: () => import('@/components/settings/Contacts.vue')
  },
  {
    path: '/video-courses',
    name: 'Video-Courses',
    component: () => import('@/components/settings/VideoCourses.vue')
  },
  {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: () => import('@/components/settings/Disclaimer.vue')
  },
  {
    path: '/disclaimer-meteotrigger',
    name: 'Disclaimer Meteotrigger',
    component: () => import('@/components/settings/Disclaimer.vue')
  },
  {
    path: '/manuals',
    name: 'Manuals',
    component: () => import('@/components/utils/Manuals.vue')
  },
  {
    path: '/layers',
    name: 'CustomerLayers',
    component: () => import('@/components/settings/CustomerLayers.vue')
  },
  {
    path: '/alert-ex-post',
    name: 'Alert Ex-Post',
    component: Home
  },
  {
    path: '/reports',
    name: 'Reports',
    component: Reports
  },
  {
    path: '/service/:id',
    name: 'Report-Hub',
    component: ReportHub
  }
];

const router = new VueRouter({
  routes
});
router.replace({ path: '', redirect: '/' });

export default router;
